import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { purchaseOrdersActions } from "../actions";
import api from "../services/purchaseOrders.service";
import { generalActions } from "../actions";
import ACTIONS from "../constants";
import { purchaseOrdersPagination } from "../selectors/purchaseOrders.selector";

function* sortPurchaseOrders(state) {
  try {
    yield put(purchaseOrdersActions.sortPurchaseOrderRequestAttempt.pending);
    const purchaseOrders = yield call(api.sortPurchaseOrdersRequest, state.payload);
    const pagination = JSON.parse(purchaseOrders.headers["x-pagination"]);
    const data = {
      data: purchaseOrders.data,
      pagination: pagination,
    };
    yield put(purchaseOrdersActions.sortPurchaseOrderRequestAttempt.success(data));
  } catch (error) {
    yield put(purchaseOrdersActions.sortPurchaseOrderRequestAttempt.error(error.message));
  }
}

function* getPurchaseOrders(state) {
  try {
    yield put(purchaseOrdersActions.getPurchaseOrdersAttempt.pending);
    const purchaseOrders = yield call(api.getPurchaseOrdersRequest, state.payload);
    const pagination = JSON.parse(purchaseOrders.headers["x-pagination"]);
    const data = {
      data: purchaseOrders.data,
      pagination: pagination,
    };
    yield put(purchaseOrdersActions.getPurchaseOrdersAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(purchaseOrdersActions.getPurchaseOrdersAttempt.error(""));
    } else {
      yield put(purchaseOrdersActions.getPurchaseOrdersAttempt.error(error.message));
    }
  }
}

function* createPurchaseOrder(state) {
  try {
    yield put(purchaseOrdersActions.createPurchaseOrderAttempt.pending);
    yield call(api.createPurchaseOrderRequest, state.payload);
    const paginat = yield select(purchaseOrdersPagination);
    const payload = {
      id: state.payload.projectId,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    // const payload = {id: state.payload.payload.ProjectId, page: paginat.CurrentPage, size: paginat.PageSize}
    const purchaseOrders = yield call(api.getPurchaseOrdersRequest, payload);
    const pagination = JSON.parse(purchaseOrders.headers["x-pagination"]);
    const data = {
      data: purchaseOrders.data,
      pagination: pagination,
    };
    yield put(purchaseOrdersActions.createPurchaseOrderAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "PurchaseOrder saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Netwrok Error!"
    ) {
      yield put(purchaseOrdersActions.createPurchaseOrderAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(purchaseOrdersActions.createPurchaseOrderAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(purchaseOrdersActions.createPurchaseOrderAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updatePurchaseOrder(state) {
  try {
    yield put(purchaseOrdersActions.updatePurchaseOrderAttempt.pending);
    yield call(api.updatePurchaseOrderRequest, state.payload);
    const paginat = yield select(purchaseOrdersPagination);
    const payload = {
      id: state.payload.projectId,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    // const payload = {id: projectID, page: paginat.CurrentPage, size: paginat.PageSize}
    const purchaseOrders = yield call(api.getPurchaseOrdersRequest, payload);
    const pagination = JSON.parse(purchaseOrders.headers["x-pagination"]);
    const data = {
      data: purchaseOrders.data,
      pagination: pagination,
    };
    yield put(purchaseOrdersActions.updatePurchaseOrderAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "PurchaseOrder updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(purchaseOrdersActions.updatePurchaseOrderAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(purchaseOrdersActions.updatePurchaseOrderAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(purchaseOrdersActions.updatePurchaseOrderAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deletePurchaseOrder(state) {
  try {
    yield put(purchaseOrdersActions.deletePurchaseOrderAttempt.pending);
    yield call(api.deletePurchaseOrderRequest, state.payload);
    const paginat = yield select(purchaseOrdersPagination);
    const payload = {
      id: state.payload.projectId,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const purchaseOrders = yield call(api.getPurchaseOrdersRequest, payload);
    const pagination = JSON.parse(purchaseOrders.headers["x-pagination"]);
    const data = {
      data: purchaseOrders.data,
      pagination: pagination,
    };
    yield put(purchaseOrdersActions.deletePurchaseOrderAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "PurchaseOrder deleted",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(purchaseOrdersActions.deletePurchaseOrderAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(purchaseOrdersActions.deletePurchaseOrderAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(purchaseOrdersActions.deletePurchaseOrderAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: errorObject.data.message || errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
  
}

function* updatePurchaseOrderFlag(state) {
  try {
    yield put(purchaseOrdersActions.updatePurchaseOrderFlagAttempt.pending);
    yield call(api.updatePurchaseOrderFlagRequest, state.payload);
    yield put(purchaseOrdersActions.updatePurchaseOrderFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "PurchaseOrder flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(purchaseOrdersActions.updatePurchaseOrderFlagAttempt.error(error.message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.SORT_PURCHASE_ORDERS_CALL, sortPurchaseOrders),
    takeEvery(ACTIONS.PURCHASE_ORDERS_CALL, getPurchaseOrders),
    takeEvery(ACTIONS.CREATE_PURCHASE_ORDER_CALL, createPurchaseOrder),
    takeEvery(ACTIONS.UPDATE_PURCHASE_ORDER_CALL, updatePurchaseOrder),
    takeEvery(ACTIONS.DELETE_PURCHASE_ORDER_CALL, deletePurchaseOrder),
    takeEvery(ACTIONS.PURCHASE_ORDER_FLAG_CALL, updatePurchaseOrderFlag),
  ]);
}
